/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestConvexCrvDepositor extends Contract<ITestConvexCrvDepositor> {
  deposit: Send<(_amount: BigNumberish, _lock: boolean) => void, ITestConvexCrvDepositor>
  'deposit(uint256,bool)': Send<(_amount: BigNumberish, _lock: boolean) => void, ITestConvexCrvDepositor>
}

let ITestConvexCrvDepositorBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestConvexCrvDepositorBytecode = '0x';
}

// prettier-ignore
export const ITestConvexCrvDepositor = contract<ITestConvexCrvDepositor>(ITestConvexCrvDepositorBytecode)`
  function deposit(uint256 _amount, bool _lock)
`;